import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-column music-viewer" }
const _hoisted_2 = {
  class: "v-row",
  style: {"flex":"1","align-items":"stretch","overflow":"hidden","margin":"20px 0"}
}
const _hoisted_3 = {
  class: "v-column",
  style: {"flex":"1"}
}
const _hoisted_4 = {
  height: "200",
  style: {"flex":"0 0 200px"},
  ref: "canvasRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_view = _resolveComponent("image-view")!
  const _component_icon = _resolveComponent("icon")!
  const _component_window_state_bar = _resolveComponent("window-state-bar")!
  const _component_lyric_view = _resolveComponent("lyric-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_image_view, {
      class: "effect-cover",
      "model-value": _ctx.cover,
      defaultValue: "icon/default_cover.jpg"
    }, null, 8, ["model-value"]),
    _createVNode(_component_window_state_bar, {
      viewer: "",
      style: {"flex":"none"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_icon, {
          name: "arrow-down",
          style: {"margin":"0 auto 0 0.5em"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_image_view, {
        class: "cover--rect-inner",
        "model-value": _ctx.cover,
        defaultValue: "icon/default_cover.jpg"
      }, null, 8, ["model-value"]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "song"),
        _createVNode(_component_lyric_view, { style: {"flex":"1"} })
      ])
    ]),
    _createElementVNode("canvas", _hoisted_4, null, 512)
  ]))
}